import { useCallback, useState } from "react";
import type { PlanEvent, Task } from "../../../shared/types";
import { track } from "../../../lib/analytics";
import { searchTasks, searchEvents } from "../utils/search-helpers";

interface SearchResults {
  tasks: Task[];
  events: PlanEvent[];
}

interface UseSearchReturn {
  query: string;
  setQuery: (query: string) => void;
  results: SearchResults;
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export function useSearch(tasks: Task[], events: PlanEvent[]): UseSearchReturn {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const results: SearchResults = {
    tasks: searchTasks(tasks, query),
    events: searchEvents(events, query),
  };

  return {
    query,
    setQuery: useCallback((q: string) => setQuery(q), []),
    results,
    isOpen,
    open: useCallback(() => {
      setIsOpen(true);
      track("search_opened", {});
    }, []),
    close: useCallback(() => {
      setIsOpen(false);
      setQuery("");
    }, []),
  };
}
